import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import { TransitionProps } from "react-transition-group/Transition";

export type FadeComponentProps<T extends React.ElementType> = Omit<
    Partial<TransitionProps<React.ComponentPropsWithRef<T>["ref"]>>,
    "children"
> & {
    baseClass?: string;
    baseClassActive?: string;
};

export type FadeProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, FadeComponentProps<T>, "div">;

export const TransitionPropTypeKeys = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
